module.exports = __webpack_public_path__ + "static/media/godragons_academy_logo_dark_text.8ab71071.png";